<template>
  <div>
    <div class="d-flex justify-space-between mt-3 mb-6">
      <v-btn icon class="ma-2" @click="$emit('prev')">
        <v-icon large color="blue">mdi-chevron-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <span class="mt-3 subtitle-1">{{ mes }}/{{ ano }}</span>
      <v-spacer></v-spacer>
      <v-btn icon class="ma-2" @click="$emit('next')">
        <v-icon large color="blue">mdi-chevron-right-circle</v-icon>
      </v-btn>
    </div>
    <div>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12" v-if="!this.empresaAtual.gate">
          <v-autocomplete
            v-model="params.gate"
            label="Gate"
            :items="selectGate"
            :item-text="
              (item) =>
                item.business_name +
                ' - ' +
                `${item.cnpj != null ? item.cnpj : item.cpf}`
            "
            item-value="public_id"
            @change="selectedGate"
            return-object
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.tipo_operacao"
            label="Tipo de operação"
            :items="selectTipoOperacao"
            item-text="descricao"
            item-value="id"
            @change="tipoOperacaoSelectdValue"
            return-object
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.fornecedor"
            label="Fornecedor"
            :items="selectFornecedor"
            :item-text="
              (item) =>
                item.business_name +
                ' - ' +
                `${item.cnpj != null ? item.cnpj : item.cpf}`
            "
            item-value="public_id"
            @change="selectedFornecedor()"
            return-object
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.regiao"
            label="Região"
            multiple
            :items="selectRegiao"
            item-text="sigla"
            item-value="public_id"
            return-object
            @change="regiaoSelectdValue"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.tipo_frete"
            label="Tipo de frete"
            :items="selectTipoFrete"
            item-text="descricao"
            item-value="id"
            return-object
            @change="tipoFreteSelectdValue"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.terminal"
            label="Terminal"
            :item-text="
              (item) =>
                item.business_name +
                ' - ' +
                `${item.cnpj != null ? item.cnpj : item.cpf}`
            "
            item-value="public_id"
            :items="selectTerminal"
            return-object
            @change="terminalSelectdValue"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.produto"
            label="Produto"
            item-text="descricao"
            item-value="id"
            :items="selectProduto"
            @change="selectedProduto()"
            return-object
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-autocomplete
            v-model="params.sub_produto"
            item-text="descricao"
            label="Sub Produto"
            item-value="id"
            :items="selectSubProduto"
            @change="subProdutoSelectdValue"
            return-object
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="params.data_inicio"
                label="De"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="params.data_inicio"
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="params.data_fim"
                label="Até"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="params.data_fim"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col class="pt-0" cols="12">
          <v-radio-group v-model="params.tipo" row>
            <v-radio label="Tonelada" value="ton"></v-radio>
            <v-radio label="Quantidade" value="qtd"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <div class="d-flex justify-center">
        <v-btn color="primary" small @click="$emit('pesquisar', params)">
          Pesquisar
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { preferencias } from '@/mixins/preferencias'
import ContratoAPI from '@/services/tenants/contratos'
import Perfil from '@/utils/perfil'
export default {
  name: 'PesquisaProgramacaoRegiao',
  data() {
    return {
      dialog: false,
      tab: null,
      mes: '',
      ano: '',
      menu1: false,
      menu2: false,
      selectGate: [],
      selectTipoOperacao: [],
      selectFornecedor: [],
      selectProduto: [],
      selectSubProduto: [],
      selectTerminal: [],
      selectRegiao: [],
      selectTipoFrete: [],
      programacoes: [],
      params: {
        gate: null,
        tipo_operacao: null,
        fornecedor: null,
        produto: null,
        sub_produto: null,
        terminal: null,
        data_inicio: null,
        data_fim: null,
        regiao: [],
        tipo_frete: null,
      },
    }
  },
  mixins: [preferencias],
  computed: {
    ...mapState('patio', [
      'programacaoUnidade',
      'programacoesUnidade',
      'terminais',
      'tiposOperacao',
      'regioes',
      'tiposFrete',
    ]),
    ...mapState('subProdutos', ['subProdutos']),
    ...mapState('produtos', ['produtos']),
    ...mapState('fornecedores', ['fornecedores']),
    ...mapState('auth', ['user', 'empresaAtual', 'perfilAtual']),
    allowedToAdd() {
      return this.empresaAtual.gate
    },
  },
  async created() {
    if (this.empresaAtual.representantes.length > 0) {
      await this.getRegioesColaborator()
    }
    if (this.empresaAtual.gate) {
      this.selectGate = [this.empresaAtual]
      this.params.gate = this.empresaAtual
      this.selectedGate()
    } else {
      const { possible_gates } = await ContratoAPI.getPossiveisGates(
        this.empresaAtual.public_id
      )
      this.selectGate = [
        { business_name: 'Nenhum', cnpj: '0', public_id: null },
        ...possible_gates,
      ]
      if (this.preferencias.gate?.public_id) {
        this.params.gate = this.preferencias.gate
        this.selectedGate()
      }
    }
    if (this.preferencias.tipo_operacao) {
      this.params.tipo_operacao = this.preferencias.tipo_operacao
    }
    if (this.preferencias.fornecedor) {
      this.params.fornecedor = this.preferencias.fornecedor
      this.selectedFornecedor()
    }
    
   
  },
  methods: {
    ...mapActions('patio', [
      'getProgramacoesUnidade',
      'getTipoOperacao',
      'getRegioes',
      'getRegioesColaborator',
      'getTiposFrete',
      'getRepresentante',
    ]),
    ...mapActions('fornecedores', ['getFornecedores','getFornecedoresByParams']),

    ...mapMutations('patio', ['setTerminal']),
    ...mapMutations('produtos', ['setProduto']),
    ...mapMutations('subProdutos', ['setSubProduto']),

    ...mapActions('template', [
      'successMessage',
      'errorMessage',
      'setDialogMessage',
    ]),
    async tipoOperacaoSelectdValue()
    {
      if (this.preferencias) {
        this.preferencias.tipo_operacao = this.params.tipo_operacao
      }
    },
    async regiaoSelectdValue()
    {
      if (this.preferencias) {
        this.preferencias.regiao = this.params.regiao
      }
    },
    async tipoFreteSelectdValue()
    {
      if (this.preferencias) {
        this.preferencias.tipo_frete = this.params.tipo_frete
      }
    },
    async terminalSelectdValue()
    {
      if (this.preferencias) {
        this.preferencias.terminal = this.params.terminal
      }
    },

    async subProdutoSelectdValue()
    {
      if (this.preferencias) {
        this.preferencias.sub_produto = this.params.sub_produto
      }
    },
    
    async selectedGate() {
      if (this.params.gate.public_id != null) {
        
        if (this.preferencias) {
          this.preferencias.gate = this.params.gate
        }
        
        await this.getTipoOperacao({ public_id: this.params.gate.public_id })
        this.selectTipoOperacao = [
          { descricao: 'Nenhum', id: null },
          ...this.tiposOperacao,
        ]
        await this.atualizarListaFornecedores()
      }
    },
    async atualizarListaFornecedores() {
      try {

        if (!this.empresaAtual.gate) {
          const fornecedores = await this.getFornecedoresByParams({
            params: {
              fornecedor: this.empresaAtual.public_id,
            },
            empresa: this.params.gate,
          })
          this.selectFornecedor = [
            { business_name: 'Nenhum', cnpj: '0', public_id: null },
            ...fornecedores,
          ]
        } else {
          await this.getFornecedores({ public_id: this.params.gate.public_id })
          this.selectFornecedor = [
            { business_name: 'Nenhum', cnpj: '0', public_id: null },
            ...this.fornecedores,
          ]
        }

      } catch (error) {
        if (
          error.response &&
          (error.response.status == 403 || error.response.status == 404)
        ) {
          this.errorMessage('Empresa não é gate para ter fornecedores.')
        } else {
          this.errorMessage(error.response.data)
        }
      }
    },
    async atualizarprogramacoesUnidade() {
      try {
        await this.getProgramacoesUnidade({
          params: null,
        })
      } catch (error) {
        if (
          error.response &&
          (error.response.status == 403 || error.response.status == 404)
        ) {
          this.errorMessage('Empresa não possui acesso as programações.')
        } else {
          this.errorMessage(error.response.data)
        }
      }
    },
    async selectedFornecedor() {
      if (this.params.fornecedor != null) {
        if (this.preferencias) {
          this.preferencias.fornecedor = this.params.fornecedor
        }
        if (this.params.fornecedor.public_id != null) {
          this.setProduto(this.params.fornecedor.produtos)
          this.selectProduto = [
            { descricao: 'Nenhum', id: null },
            ...this.produtos,
          ]
          this.setTerminal(
            await ContratoAPI.getContratos(
              this.params.fornecedor.fornecedor_id,
              {
                perfil: Perfil.Terminal,
              }
            )
          )
          this.selectTerminal = [
            { business_name: 'Nenhum', cnpj: '0', public_id: null },
            ...this.terminais,
          ]

          // Filtrando as regioes de um representante
          if (this.empresaAtual.representantes.length > 0) {
            await this.getRegioesColaborator()
          } else {
            await this.getRegioes({
              public_id: this.params.fornecedor.fornecedor_id,
            })
          }

          this.selectRegiao = [
            { sigla: 'Nenhum', public_id: null },
            ...this.regioes,
          ]
          await this.getTiposFrete({
            public_id: this.params.fornecedor.fornecedor_id,
          })
          this.selectTipoFrete = [
            { descricao: 'Nenhum', id: null },
            ...this.tiposFrete,
          ]

          

        } else {
          this.selectProduto = [{ descricao: 'Nenhum', id: null }]
          this.selectTerminal = [
            { business_name: 'Nenhum', cnpj: '0', public_id: null },
          ]
          this.selectRegiao = [{ sigla: 'Nenhum', public_id: null }]
          this.selectTipoFrete = [{ descricao: 'Nenhum', id: null }]
        }
      } else {
        this.selectProduto = [{ descricao: 'Nenhum', id: null }]
        this.selectTerminal = [
          { business_name: 'Nenhum', cnpj: '0', public_id: null },
        ]
        this.selectRegiao = [{ sigla: 'Nenhum', public_id: null }]
        this.selectTipoFrete = [{ descricao: 'Nenhum', id: null }]
      }
      
      if (this.preferencias.produto) {
        this.params.produto = this.preferencias.produto
      }else{
        this.params.produto = null
      }

      if (this.preferencias.sub_produto) {
        this.params.sub_produto = this.preferencias.sub_produto
      }else{
        this.params.sub_produto = null
      }

      if (this.preferencias.terminal) {
        this.params.terminal = this.preferencias.terminal
      }else{
        this.params.terminal = null
      }

      if (this.preferencias.regiao) {
        this.params.regiao = this.preferencias.regiao
      }else{
        this.params.regiao = null
      }

      if (this.preferencias.tipo_frete) {
        this.params.tipo_frete = this.preferencias.tipo_frete
      }else{
        this.params.tipo_frete = null
      }

      this.selectedProduto()
    },
    selectedProduto() {
      if (this.preferencias) {
        this.preferencias.produto = this.params.produto
      }
      if (this.params.produto != null) {
        if (this.params.produto.id != null) {
          this.setSubProduto(this.params.produto.subprodutos)
          this.selectSubProduto = [
            { descricao: 'Nenhum', id: null },
            ...this.subProdutos,
          ]
        } else {
          this.selectSubProduto = [{ descricao: 'Nenhum', id: null }]
          this.params.sub_produto = null
        }
      } else {
        this.selectSubProduto = [{ descricao: 'Nenhum', id: null }]
        this.params.sub_produto = null
      }
    },
  },
}
</script>
